import _ from 'lodash';

/**
 * Convertit un numéro de téléphone saisi librement (ex : logiciel état civil,
 * sans contrôle de format) en valeur exploitable par le composant `PhoneInput`.
 *
 * `PhoneInput` n'affiche que les valeurs commençant par un indicatif (`+`) :
 * un numéro national ("06 12 34 56 78", "061234567", etc.) serait affiché vide.
 * On ramène donc systématiquement le numéro à la forme `+<chiffres>` pour qu'il
 * soit affiché, même s'il est invalide (le champ est alors signalé en erreur) :
 * - "+41 22 123 45 67" -> "+41221234567"
 * - "0033612345678" -> "+33612345678"
 * - "06.12.34.56" -> "+336123456"
 * - "612345678" -> "+33612345678"
 *
 * Un numéro sans aucun chiffre est renvoyé tel quel.
 *
 * À n'utiliser que pour l'affichage : la valeur stockée reste le numéro brut
 * tant que l'utilisateur ne le modifie pas.
 */
const toPhoneInputValue = (phoneNumber?: string | null): string | null => {
  if (_.isNil(phoneNumber)) return null;

  const raw = _.trim(phoneNumber);
  if (!raw) return null;

  const digits = raw.replace(/\D/g, '');
  if (!digits) return raw;

  if (raw.startsWith('+')) return `+${digits}`;
  if (digits.startsWith('00')) return `+${digits.substring(2)}`;
  if (digits.startsWith('0')) return `+33${digits.substring(1)}`;

  return `+33${digits}`;
};

export default toPhoneInputValue;
